export type AssistantSecondaryVisibleCounts = {
    readonly exploreNextVisibleCount: number;
    readonly quickActionsVisibleCount: number;
    readonly followUpsVisibleCount: number;
    readonly suggestionsVisibleCount: number;
    readonly isFeedbackToolbarVisible: boolean;
};

type ComputeAssistantSecondaryVisibleCountsParams = {
    readonly exploreNextLength: number;
    readonly visibleQuickActionsLength: number;
    readonly followUpsLength: number;
    readonly suggestionsLength: number;
    readonly hasFeedbackToolbar: boolean;
    readonly revealedSecondaryCount: number;
};

export const computeAssistantSecondaryVisibleCounts = ({
    exploreNextLength,
    visibleQuickActionsLength,
    followUpsLength,
    suggestionsLength,
    hasFeedbackToolbar,
    revealedSecondaryCount,
}: ComputeAssistantSecondaryVisibleCountsParams): AssistantSecondaryVisibleCounts => {
    let cursor = 0;
    const takeVisible = (sectionLength: number): number => {
        const visibleCount = Math.max(0, Math.min(sectionLength, revealedSecondaryCount - cursor));
        cursor += sectionLength;

        return visibleCount;
    };

    return {
        exploreNextVisibleCount: takeVisible(exploreNextLength),
        quickActionsVisibleCount: takeVisible(visibleQuickActionsLength),
        followUpsVisibleCount: takeVisible(followUpsLength),
        suggestionsVisibleCount: takeVisible(suggestionsLength),
        isFeedbackToolbarVisible: hasFeedbackToolbar && revealedSecondaryCount > cursor,
    };
};
